module.exports = __webpack_public_path__ + "img/SCC_Myofibroblasts.cbda806f.png";